export default "__VITE_PUBLIC_ASSET__034a836e__"